<div class="form-wrapper">
    <form class="login-form" #form="ngForm">
        <mat-form-field>
            <mat-label>{{'EnterNewPassword'|translate}}</mat-label>
            <input matInput type="text" [ngModel]="hotelLoginModel.Password" name="Password" placeholder="Just a placeholder">
        </mat-form-field>
        <button type="button" class="btn btn-success btn-lg submit-btn" (click)="resetPass(form)">{{'Reset'|translate}}</button>
    </form>
</div>